define.alias("shared/modifiers/circular-upload-animation", "calendar/modifiers/circular-upload-animation");